import React from 'react';

import { renderHookLabel } from '../_common';

interface FakeLabelProps {
  fieldName: string;
  label?: string;
  required?: boolean;
}

const FakeLabel = ({ fieldName, label, required }: FakeLabelProps) => {
  return <div className="hook-fake-label">{renderHookLabel(fieldName, label, required)}</div>;
};

export default FakeLabel;
